import React, { useState, useEffect, useContext } from "react";
import styles from "./Search.module.css";
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";
import { inventoryProducts, displayItem } from "../Home/Home";
import Button from "@mui/material/Button";
import { productData } from "../Constant/ConstantRegister";

export const moldingsiteName = [
  { moldingsite: "A-1", part: "股装具" },
  { moldingsite: "A-4", part: "膝装具" },
  { moldingsite: "A-6", part: "短下肢装具" },
  { moldingsite: "A-7", part: "足底装具、足趾装具" },
  { moldingsite: "C-1", part: "頚椎装具（胸腰仙椎装具付）" },
  { moldingsite: "C-2", part: "頚胸椎装具" },
  { moldingsite: "C-3", part: "頚椎装具（カラー）" },
  { moldingsite: "C-5", part: "胸腰仙椎装具" },
  { moldingsite: "C-6", part: "腰仙椎装具、仙腸装具" },
  { moldingsite: "D-1", part: "肩装具" },
  { moldingsite: "D-3", part: "肘装具" },
  { moldingsite: "D-4", part: "手関節装具" },
  { moldingsite: "D-5", part: "手装具" },
  { moldingsite: "D-6", part: "指装具" },
];

export default function Search() {
  const [products, setProducts] = useState<inventoryProducts[]>([]);
  const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
  const [selectedManufacture, setSelectedManufacture] = useState<string>("");
  const [selectedMoldingSite, setSelectedMoldingSite] = useState<string>("");
  const [selectProduct, setSelectProduct] = useState<string[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string>("");
  const [selectedProductData, setSelectedProductData] = useState<productData>();
  const [selectedDisplay, setSelectedDisplay] = useState<string>("");
  const [selectDisplayItem, setSelectDisplayItem] = useState<boolean[]>([
    false,
    false,
    false,
  ]);
  const { setAuth } = useContext(AuthContext) as AuthContextType;
  const navigate = useNavigate();
  const [searched, setSearched] = useState<boolean>(false);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [selectedLeftRight, setSelectedLeftRight] = useState<string>("");
  const [selectedSize, setSelectedSize] = useState<string>("");

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };

    checkAuth();

    const fetchSelectInit = async () => {
      const response = await fetch(`${baseUrl}/getmanufacture`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      const Manufactures = data.manufacture.map((item: Object) =>
        Object.values(item)
      );
      setSelectManufacture(Manufactures);
    };
    fetchSelectInit();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchProduct = async () => {
      const response = await fetch(`${baseUrl}/product`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          manufacture: selectedManufacture,
          moldingsite: selectedMoldingSite,
        }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setSelectProduct(data);
    };
    fetchProduct();
  }, [selectedManufacture, selectedMoldingSite, navigate]);

  useEffect(() => {
    const fetchProductData = async () => {
      if (selectedProduct === "") {
        return;
      }
      const response = await fetch(`${baseUrl}/productdata_productname`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productname: selectedProduct }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        alert("セッションが切れました。再度ログインしてください");
        setAuth({
          username: null,
          isAuthenticated: false,
          office: undefined,
          authority: "user",
        });
        return navigate("/login");
      }
      setSelectedProductData(data);
      setSelectedColor(data.color[0]);
      setSelectedLeftRight(data.leftright[0]);
      setSelectedSize(data.size[0]);
    };
    fetchProductData();
  }, [selectedProduct, navigate, setAuth]);

  const searchProducts = async () => {
    if (!selectedManufacture && !selectedMoldingSite && !selectedProduct) {
      alert("検索条件を1つ以上設定してください");
      return;
    }
    const searchTerm = {
      manufacture: selectedManufacture,
      moldingsite: selectedMoldingSite,
      productname: selectedProduct,
      color: selectedColor,
      left_right: selectedLeftRight,
      size: selectedSize,
      display: selectedDisplay,
    };
    console.log(searchTerm);
    const response = await fetch(`${baseUrl}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(searchTerm),
    });
    const data = await response.json();
    if (data.isAuth === false) {
      alert("セッションが切れました。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    setProducts(data);
    setSearched(true);
  };

  const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedManufacture(e.target.value);
    setSelectedProduct("");
    setSelectedProductData(undefined);
    setSelectedColor("");
    setSelectedLeftRight("");
    setSelectedSize("");
  };

  const handleMoldingSite = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMoldingSite(e.target.value);
    setSelectedProductData(undefined);
    setSelectedProduct("");
    setSelectedColor("");
    setSelectedLeftRight("");
    setSelectedSize("");
  };

  const handleProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProduct(e.target.value);
  };

  const handleDisplay = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDisplay(e.target.value);
  };

  const handleDisplayItem = (index: number) => {
    let newDisplay = [...selectDisplayItem];
    newDisplay[index] = !newDisplay[index];
    setSelectDisplayItem(newDisplay);
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>全店検索</h2>
      <div className={styles.selecterwrapper}>
        <p className={styles.p2}>検索条件：</p>
        <label htmlFor="メーカー" className={styles.label}>
          メーカー
          <select
            value={selectedManufacture}
            id="メーカー"
            onChange={handleManufacture}
            className={styles.select}
          >
            <option value="">未設定</option>
            {selectManufacture.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="装着部位" className={styles.label}>
          装着部位
          <select
            value={selectedMoldingSite}
            id="装着部位"
            onChange={handleMoldingSite}
            className={styles.select}
          >
            <option value="">未設定</option>
            {moldingsiteName.map((item) => (
              <option key={item.moldingsite} value={item.moldingsite + "%"}>
                {item.part}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="製品" className={styles.label}>
          製品
          <select
            value={selectedProduct}
            id="製品"
            onChange={handleProduct}
            className={styles.select}
          >
            <option value="">未設定</option>
            {selectProduct.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className={styles.selecterwrapper}>
        <label htmlFor="色" className={styles.label}>
          色
          <select
            value={selectedColor}
            id="色"
            onChange={(e) => setSelectedColor(e.target.value)}
            className={styles.select}
          >
            {selectedProductData?.color.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="左右" className={styles.label}>
          左右
          <select
            value={selectedLeftRight}
            id="左右"
            onChange={(e) => setSelectedLeftRight(e.target.value)}
            className={styles.select}
          >
            {selectedProductData?.leftright.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="サイズ" className={styles.label}>
          サイズ
          <select
            value={selectedSize}
            id="サイズ"
            onChange={(e) => setSelectedSize(e.target.value)}
            className={styles.select}
          >
            {selectedProductData?.size.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>

        <label htmlFor="表示" className={styles.label}>
          表示
          <select
            value={selectedDisplay}
            id="表示"
            onChange={handleDisplay}
            className={styles.select}
          >
            <option value="">すべて</option>
            <option value="constant">定数在庫分</option>
            <option value="excess">超過分</option>
            <option value="temporarily">一時出庫分</option>
          </select>
        </label>

        <Button
          onClick={searchProducts}
          variant="contained"
          sx={{ height: 40, margin: 3 }}
        >
          検索
        </Button>
      </div>

      <div className={styles.checkwrapper}>
        <p className={styles.p2}>表示項目：</p>
        {displayItem.map((item, index) => (
          <label
            htmlFor={item.value}
            key={item.value}
            className={styles.checkArea}
          >
            {item.name}
            <input
              type="checkbox"
              id={item.value}
              onChange={() => handleDisplayItem(index)}
              className={styles.checkbox}
            />
          </label>
        ))}
      </div>
      <div className={styles.scroll}>
        {!searched ? (
          <p className={styles.nodata}>
            条件を選択して検索ボタンを押してください。
          </p>
        ) : products.length < 1 ? (
          <p className={styles.nodata}>条件に一致する製品がありません。</p>
        ) : (
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr>
                <th className={styles.th}>支店</th>
                <th className={styles.th}>メーカー</th>
                <th className={styles.th}>製品名</th>
                <th className={styles.th}>色</th>
                <th className={styles.th}>左右</th>
                <th className={styles.th}>サイズ</th>
                {selectDisplayItem[3] ? null : (
                  <th className={styles.th}>在庫数</th>
                )}
                {selectDisplayItem[0] ? (
                  <th className={styles.th}>定数</th>
                ) : null}
                {selectDisplayItem[1] ? (
                  <th className={styles.th}>超過分</th>
                ) : null}
                {selectDisplayItem[2] ? (
                  <th className={styles.th}>一時出庫</th>
                ) : null}
              </tr>
            </thead>
            <tbody className={styles.block}>
              {products.map((item, index) => (
                <tr key={index} className={styles.tr}>
                  <td className={styles.td}>{item.office}</td>
                  <td className={styles.td}>{item.manufacture}</td>
                  <td className={styles.td}>{item.productname}</td>
                  <td className={styles.td}>{item.color}</td>
                  <td className={styles.td}>{item.left_right}</td>
                  <td className={styles.td}>{item.size}</td>
                  {selectDisplayItem[3] ? null : (
                    <td className={styles.td}>{item.quantity}</td>
                  )}
                  {selectDisplayItem[0] ? (
                    <td className={styles.td2}>{item.constant}</td>
                  ) : null}
                  {selectDisplayItem[1] ? (
                    <td className={styles.td2}>
                      {item.quantity - item.constant > 0
                        ? item.quantity - item.constant
                        : null}
                    </td>
                  ) : null}
                  {selectDisplayItem[2] ? (
                    <td className={styles.td2}>
                      {item.temporarily_quantity
                        ? item.temporarily_quantity
                        : null}
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
